// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, string } from 'prop-types'
import UpdatedMultiSelect from '../UpdatedMultiSelect'
import { useOptionsFromState } from './hooks'

const UpdatedMultiSelectFromState = ({ labelKey, valueKey, targetSet, ...props }) => {
  const options = useOptionsFromState(targetSet)

  return (
    <UpdatedMultiSelect
      {...props}
      labelKey={labelKey}
      options={options}
      valueKey={valueKey} />
  )
}

UpdatedMultiSelectFromState.propTypes = {
  id: string.isRequired,
  labelKey: string.isRequired,
  targetSet: array.isRequired,
  valueKey: string.isRequired,
}

export default UpdatedMultiSelectFromState
